declare global {
  interface Window {
    dataLayer: {
      push: (args: Record<string, unknown>) => void;
    };
  }
}

export const dataLayer = (eventParams: Record<string, unknown>) => {
  if (typeof window !== 'undefined') {
    (window as Window)?.dataLayer?.push(eventParams);
  }
};
